<script>
import DataLabel from '@/js/components/common/labels/DataLabel';
import {validate as validateEmail} from 'email-validator';

export default {
    name: 'EmailLabel',

    functional: true,

    props: {
        email: {type: String, default: null},
        iconClass: { type: String, default: 'far fa-fw fa-envelope' }
    },

    render(createElement, {props, data, parent, children}) {
        const isEmpty = !props.email || props.email.length === 0;

        const href = (!isEmpty && validateEmail(props.email))
            ? 'mailto:' + props.email
            : null;

        data.props = {
            item: isEmpty ? null : props.email,
            iconClass: props.iconClass,
            none: parent.$t('common.labels.email.nil'),
            href: href,
        };

        return createElement(DataLabel, data, children);
    },
};
</script>
